import {
  CellWrapper,
  DisabledTag
} from '@nile/mangifera/src/Pebbles/TicketContainer';
import {
  DateTimeFormatter,
  DateTimePicker,
  getTranslatedText
} from '@nile/components';
import dayjs from 'dayjs';
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const DateWrapper = styled.div`
  .react-datepicker__input-container > input,
  .react-datepicker__input-container,
  .react-datepicker-wrapper {
    height: 100%;
    width: 100%;
  }
  .react-datepicker__input-container > input {
    margin-right: 14px;
    padding: 6px;
    height: 100%;
    font-size: 14px;
  }
  .react-datepicker__tab-loop {
    position: relative;
  }
`;

function DateTimeCell(props) {
  const { cell, params } = props;
  const allProps = params || cell.column;
  const { editable, editMode, actions } = allProps;
  const type = cell?.column?.dataType;
  const intl = useIntl();
  if (editable && editMode) {
    return (
      <DateWrapper>
        <DateTimePicker
          selected={dayjs(cell?.value || new Date()).toDate()}
          onChange={(val) => {
            actions.onChange({
              key: 'billedDate',
              value: dayjs(val).format('YYYY-MM-DD'),
              field: cell.row.original
            });
          }}
          placeholderText={getTranslatedText(
            intl,
            'invoice.details.invoiceDate'
          )}
          // dateFormat="yyyy-MM-dd"
          required
          disabled={false}
          popperPlacement="auto"
          // withPortal
          minDate={null}
          portalId="root-portal"
        />
      </DateWrapper>
    );
  }
  return cell.value ? (
    <CellWrapper>
      <div className="ellipsis" title={cell.value}>
        <DateTimeFormatter type={type || 'dateTime'} date={cell.value} />
      </div>
    </CellWrapper>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default DateTimeCell;
